export default function Go_Modify_Slices () {
  return (
    <div>
      <h1>Go_Modify_Slices </h1>
      <p>Modify Slices</p>
    </div>
  );
}